import React from 'react';
import { Button } from '../../components/Button/Button';
import './EndFlowScreen.css';

type EndFlowScreenProps = {
  image: string;
  title?: string;
  content: Array<{ [key: string]: string }> | [];
  buttonPrimary?: {
    text: string;
    onClick: () => void;
  };
  buttonSecondary?: {
    text: string;
    onClick: () => void;
  };
  splitContent?: boolean;
};

export const EndFlowScreen: React.FC<EndFlowScreenProps> = ({
  image,
  buttonPrimary,
  buttonSecondary,
  title,
  content,
  splitContent = true,
}) => {
  return (
    <div className="end-flow-screen--container">
      <div className="end-flow-screen--body">
        <div className="end-flow-screen--content">
          <img src={image} className="end-flow-screen--image" />
          {title && <h2 className="end-flow-screen--title">{title}</h2>}
          {content.map((e, i) => {
            return splitContent ? (
              <>
                <p className="end-flow-screen--description" key={`${i}-key`}>
                  {e.title}
                </p>
                <p className="end-flow-screen--sub-description" key={i}>
                  {e.label}
                </p>
              </>
            ) : (
              <p className="end-flow-screen--sub-and-description" key={i}>
                <b>{e.title}</b> {e.label}
              </p>
            );
          })}
        </div>
        {buttonPrimary && (
          <div className="end-flow-screen--button-container">
            <Button
              onClick={buttonPrimary.onClick}
              isWhite
              label={buttonPrimary.text}
            />
          </div>
        )}
        {buttonSecondary && (
          <div className="end-flow-screen--button-container">
            <Button
              onClick={buttonSecondary.onClick}
              label={buttonSecondary.text}
            />
          </div>
        )}
      </div>
    </div>
  );
};
